import React from "react";
import { Route } from "react-router";

import DefaultLink from "../../../shared/items/static/defaultLink";
import TitleContent from "../../../shared/titleContent";
import Icon from "../../../shared/items/static/icon";
import LinkIconWrapper from "../../../shared/items/contols/linkIconWrapper";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";

import styles from "./reportHistoryContentTitle.module.scss";

const REPORT_CONTENT_TITLE = "Отчёты";
const REPORT_HISTORY_TITLE = "История просмотренных отчетов";
const REPORT_SAVED_TITLE = "Архив отчетов";

const ReportHistoryContentTitle = () => {
  return (
    <div className={styles.container_reportHeader}>
      <div className={styles.container_title}>
        <Route path="/history-reports" render={() => <TitleContent title={REPORT_HISTORY_TITLE} />} />
        <Route path="/saved-reports" render={() => <TitleContent title={REPORT_SAVED_TITLE} />} />
      </div>
      <div className={styles.container_links}>
        <div className={styles.container_linkItem}>
          <Route
            path="/saved-reports"
            render={() => (
              <TooltipWrapper title="История просмотренных отчетов" position="top">
                <div>
                  <LinkIconWrapper type="secondary" icon="history" link="/history-reports" />
                </div>
              </TooltipWrapper>
            )}
          />
          <Route
            path="/history-reports"
            render={() => (
              <TooltipWrapper title="Архив отчётов" position="top">
                <div>
                  <LinkIconWrapper type="secondary" icon="bookmark" link="/saved-reports" />
                </div>
              </TooltipWrapper>
            )}
          />
        </div>
      </div>
      <div className={styles.container_backLink}>
        <DefaultLink link={`/reports/`}>
          <span className={styles.container_backIcon}>
            <Icon className="asd" name="backward" />
          </span>
          <span className={styles.backTitle}>{REPORT_CONTENT_TITLE}</span>
        </DefaultLink>
      </div>
    </div>
  );
};

export default React.memo(ReportHistoryContentTitle);
